/** Digits typed so far, formatted live as XXX-XXX-XXXX. Anything past the 10th digit is dropped. */
export const formatPhoneInput = (raw: string): string => {
    const digits = raw.replace(/\D/g, "").slice(0, 10);
    const areaCode = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const line = digits.slice(6, 10);
    if (digits.length > 6) return `${areaCode}-${prefix}-${line}`;
    if (digits.length > 3) return `${areaCode}-${prefix}`;
    return areaCode;
};
